import axios from 'axios'
import { useToast } from 'vue-toastification'
import { useMainStore } from '@/store'
// import router from '@/router'
import static_vars from '../staticVars.js'

const toast = useToast()

// const handleUnauthorizedToken = () => {
//     const store = useMainStore()
//     toast('Authentication expired. Please login again', {
//         type: 'error'
//     })
//     store.$reset()
//     router.replace('/')
// }


export const post = (url, params,token) => {
    return new Promise((resolve, reject) => {
        const store = useMainStore()
        const headers = {}
        if (store.user.access_token) {//After login
            headers['Authorization'] = `Bearer ${store.user.access_token}`
        }
        if (token) {//for login api 
            headers['Authorization'] = token == 'basic' ? `Basic ${Buffer.from(`${static_vars.CLIENT_ID}:${static_vars.CLIENT_SECRET}`).toString('base64')}` : `Bearer ${store.user.token}`
        }
        headers['Content-Type'] = (token && token == 'basic') ? 'application/x-www-form-urlencoded' : 'application/json'
        headers['Accept'] = 'application/json'
        headers['Content-Encoding'] = 'gzip, deflate, br'
        axios.post(
            url,
            params,
            { headers }
        ).then(response => {
            if(response.data.status && response.data.status === 404){
                toast(response.data.message, {
                    type: 'error'
                })
                // store.error.msg = response.data.message
                // store.error.type = 'error'
                // setTimeout(function () {
                //     store.clearMessage()
                // },10000);
                reject(response.data)
            }else{
                resolve(response.data)
            }
        }).catch(error => {
            if (error.response?.status === 401) {
                if(error?.response?.data?.message){
                    toast(error.response.data.message, {
                        type: 'error'
                    })
                }else{
                    toast(error.response.data.error_description, {
                        type: 'error'
                    })
                    store.$reset()
                    window.open('//zulutrade.com/login')
                }
                reject(error)
            } else {
                if(error?.response?.data?.message){
                    toast(error.response.data.message, {
                        type: 'error'
                    })
                }else{
                    toast(error.response.data.error_description, {
                        type: 'error'
                    })
                }
                reject({ ...error })
            }
        })
    })
}

export const put = (url, params,token) => {
    return new Promise((resolve, reject) => {
        const store = useMainStore()
        const headers = {}
        if (store.user.access_token) {//After login
            headers['Authorization'] = `Bearer ${store.user.access_token}`
        }
        if (token) {//for login api 
            headers['Authorization'] = token == 'basic' ? `Basic ${Buffer.from(`${static_vars.CLIENT_ID}:${static_vars.CLIENT_SECRET}`).toString('base64')}` : `Bearer ${store.user.token}`
        }
        headers['Content-Type'] = (token && token == 'basic') ? 'application/x-www-form-urlencoded' : 'application/json'
        headers['Accept'] = 'application/json'
        headers['Content-Encoding'] = 'gzip, deflate, br'
        axios.put(
            url,
            params,
            { headers }
        ).then(response => {
            if(response.data.status && response.data.status === 404){
                toast(response.data.message, {
                    type: 'error'
                })
                // store.error.msg = response.data.message
                // store.error.type = 'error'
                // setTimeout(function () {
                //     store.clearMessage()
                // },10000);
                reject(response.data)
            }else{
                resolve(response.data)
            }
        }).catch(error => {
            if (error.response?.status === 401) {
                if(error?.response?.data?.message){
                    toast(error.response.data.message, {
                        type: 'error'
                    })
                }else{
                    toast(error.response.data.error_description, {
                        type: 'error'
                    })
                    store.$reset()
                    window.open('//zulutrade.com/login')
                }
                reject(error)
            } else {
                if(error?.response?.data?.message){
                    toast(error.response.data.message, {
                        type: 'error'
                    })
                }else{
                    toast(error.response.data.error_description, {
                        type: 'error'
                    })
                }
                reject({ ...error })
            }
        })
    })
}

export const get = (url) => {
    return new Promise((resolve, reject) => {
        const store = useMainStore()
        const headers = {}
        if (store.user?.access_token || localStorage.getItem("zulutoken")){
            headers['Authorization'] = `Bearer ${store.user?.access_token || localStorage.getItem("zulutoken")}`
        }
        const s = url.split('/')
        const t = s[s.length-1]
        if(t == 'lod'){
            headers['Accept'] = '*/*'
            headers['Content-Type'] = 'application/pdf'
            headers['content-disposition'] = 'inline;filename=deltastockLod.pdf'
        } else {
            headers['Content-Type'] = 'application/json'
            headers['Accept'] = 'application/json'
        }
        headers['Content-Encoding'] = 'gzip, deflate, br'
        axios.get(
            url, { headers,responseType: t == 'lod' ? 'arraybuffer' : 'json' }, 
        ).then(response => {
            if(response.data.status && response.data.status === 404){
                toast(response.data.message, {
                    type: 'error'
                })
                // store.error.msg = response.data.message
                // store.error.type = 'error'
                // setTimeout(function () {
                //     store.clearMessage()
                // },10000);
                reject(response.data)
            }else{
                resolve(response.data)
            }
        }).catch(error => {
            if (error.response?.status === 401) {
                if(error?.response?.data?.message){
                    toast(error.response.data.message, {
                        type: 'error'
                    })
                }else{
                    toast(error.response.data.error_description, {
                        type: 'error'
                    })
                    store.$reset()
                    window.open('//zulutrade.com/login')
                }
                reject(error)
            } else {
                if(error?.response?.data?.message){
                    toast(error.response.data.message, {
                        type: 'error'
                    })
                }else {
                    let showError = true;
                    let demo_account = false;
                    Object.keys(store?.userAccoutDetail?.accounts).forEach(function(acc){
                        if(store?.userAccoutDetail?.accounts[acc].demo == true){
                            demo_account = true;
                        } 
                    });

                    if( url.includes('flavors/api/flavors/light/secure') && demo_account == false)
                    {   
                        showError = false
                    }
                    if(showError){
                        toast(error.response.data.error_description, {
                            type: 'error'
                        })
                    }
                }
                reject({ ...error })
            }
        })
    })
}

export const DELETE = (url,params) => {
    try{
        return new Promise((resolve, reject) => {
            const store = useMainStore()
            const headers = {}
            if (store.user.access_token) {
                headers['Authorization'] = `Bearer ${store.user.access_token}`
            }
            headers['Content-Type'] = 'application/json'
            headers['Accept'] = 'application/json'
            headers['Content-Encoding'] = 'gzip, deflate, br'
            axios.delete(url,{
                data : params,
                headers 
            }).then(response => {
                if (response.data.status && response.data.status === 404) {
                    toast(response.data.message, {
                        type: 'error'
                    })
                    // store.error.msg = response.data.message
                    // store.error.type = 'error'
                    // setTimeout(function () {
                    //     store.clearMessage()
                    // },10000);
                reject(response.data)
                } else {
                    resolve(response.data)
                }
            }).catch(error => {
                if (error.response?.status === 401) {
                    if(error?.response?.data?.message){
                        toast(error.response.data.message, {
                            type: 'error'
                        })
                    }else{
                        toast(error.response.data.error_description, {
                            type: 'error'
                        })
                        store.$reset()
                        window.open('//zulutrade.com/login')
                    }
                    reject(error)
                } else {
                    if(error?.response?.data?.message){
                        toast(error.response.data.message, {
                            type: 'error'
                        })
                    }else{
                        toast(error.response.data.error_description, {
                            type: 'error'
                        })
                    }
                    reject({ ...error })
                }
            })
        })
    }catch(e){
        console.log('e',e)
    }
}